module.exports = __webpack_public_path__ + "img/right-arrow-bg.1003b7b2.svg";